<template>
  <div>
    <!--begin::Advance Table Widget 10-->
    <div class="card card-custom gutter-b">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label text-dark">
            <span>发票抬头信息</span>
          </span>
        </h3>
        <div class="card-toolbar">
          <AddInvTitle
            v-bind:dialog.sync="invTitleDialog"
            :form="form"
            :action="action"
          ></AddInvTitle>
          <v-btn
            @click="openDialog"
            color="primary font-weight-bolder font-size-sm"
            >添加发票抬头</v-btn
          >
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_4"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="width: 30px">
                  <label class="checkbox checkbox-lg checkbox-single mr-2">
                    <input
                      type="checkbox"
                      @input="setCheck($event.target.checked)"
                    />
                    <span></span>
                  </label>
                </th>
                <th class="pl-0" style="min-width: 120px">发票抬头</th>
                <th style="min-width: 110px">发票类型</th>
                <th style="min-width: 110px">纳税人识别号</th>
                <th style="min-width: 110px">收票电子邮箱</th>
                <th class="pr-0 text-right" style="min-width: 160px">动作</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in list">
                <tr v-bind:key="i">
                  <td class="pl-0 py-6">
                    <label class="checkbox checkbox-lg checkbox-single">
                      <input type="checkbox" :value="i" :checked="checked" />
                      <span></span>
                    </label>
                  </td>

                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.business_name }}</span
                    >
                    <span class="text-muted font-weight-bold">{{
                      item.country_desc
                    }}</span>
                  </td>
                  <td>
                    <span
                      class="text-primary font-weight-bolder d-block font-size-lg"
                      >{{ item.inv_type }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.tax_id }}</span
                    >
                  </td>

                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.email }}</span
                    >
                  </td>

                  <td class="pr-0 text-right">
                    <a
                      @click="editData(item)"
                      class="btn btn-icon btn-light btn-hover-primary btn-sm"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-primary">
                        <i class="la la-edit"></i>
                      </span>
                    </a>
                    <a
                      @click="deleteData(item)"
                      class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-primary">
                        <i class="la la-trash"></i>
                      </span>
                    </a>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 10-->
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="limit"
      aria-controls="my-table"
      class="mt-3 text-right float-right"
    ></b-pagination>
  </div>
</template>

<script>
import { getInstance, deleteInstance } from "@/api/instance";
import AddInvTitle from "@/view/pages/invoice/AddInvTitle";
export default {
  name: "Invoice",
  data() {
    return {
      checked: false,
      list: [],
      invTitleDialog: false,
      form: {
        inv_type: "增值税电子普通发票",
      },
      action: "add",
      currentPage: 1,
      pagination: {
        total: "",
      },
      limit: 10,
    };
  },
  components: { AddInvTitle },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchInvTitle({
          $limit: this.limit,
          $start: this.currentPage * this.limit - this.limit,
        });
      },
      deep: true,
    },
  },
  created() {
    this.fetchInvTitle({ $limit: this.limit });
  },
  methods: {
    setCheck(check) {
      if (check) {
        this.checked = check;
      } else {
        this.checked = false;
      }
    },
    openDialog() {
      this.action = "add";
      this.form = { inv_type: "增值税电子普通发票" };
      this.invTitleDialog = true;
    },
    fetchInvTitle(params) {
      getInstance("INVTITLE", params).then((res) => {
        this.list = res.result;
        this.pagination.total = res.total;
      });
    },
    editData(item) {
      this.action = "edit";
      this.form = item;
      this.invTitleDialog = true;
    },
    deleteData(item) {
      this.$bvModal
        .msgBoxConfirm("此操作将永久删除该记录，是否继续？", {
          title: "提示",
          okVariant: "warning",
          okTitle: "确认",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((val) => {
          if (val) {
            deleteInstance("INVTITLE", { _id: item._id["$oid"] }).then(() => {
              this.fetchInvTitle();
            });
          }
        });
    },
  },
};
</script>
